import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

export function Navigation() {
  const [activeSection, setActiveSection] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const sectionIds = ['about', 'certifications', 'stack', 'experience', 'work', 'contact'];
    const onScroll = () => {
      const scrollY = window.scrollY + 120;
      let current = '';
      sectionIds.forEach(id => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) current = id;
      });
      setActiveSection(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { href: '#about', label: 'ABOUT', id: 'about' },
    { href: '#certifications', label: 'CERTIFICATIONS', id: 'certifications' },
    { href: '#stack', label: 'SKILLS', id: 'stack' },
    { href: '#experience', label: 'EXPERIENCE', id: 'experience' },
    { href: '#contact', label: 'CONTACT', id: 'contact' },
  ];

  return (
    <nav className="nav">
      <div className="nav-inner">
        <button
          className="nav-hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </button>
        <div className={`nav-links${menuOpen ? ' nav-links-open' : ''}`}>
          {navLinks.map(link => (
            <a
              key={link.id}
              href={link.href}
              className={activeSection === link.id ? 'active' : ''}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a className="resume" href="/Sathish-Kalaimani-Resume.pdf" onClick={() => setMenuOpen(false)}>
            RESUME
          </a>
        </div>
      </div>
    </nav>
  );
}
